import { render } from "./Blog5View.vue?vue&type=template&id=57ffb7d5"
import script from "./Blog5View.vue?vue&type=script&lang=js"
export * from "./Blog5View.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__